import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-clients',
	templateUrl: './clients.component.html',
	styleUrls: ['./clients.component.scss']
})
export class ClientsComponent {

	baseUrl: any;
	imagepath: any;


	clientslider: OwlOptions = {
		loop: true,
		autoplay: true,
		mouseDrag: true,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		// navSpeed: 0,
		slideTransition: 'linear',
		autoplaySpeed: 3000,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
		// smartSpeed: 0,
		nav: false,
		center: false,
		navText: ['<i class="fas fa-arrow-left"></i>', '<i class="fas fa-arrow-right"></i>'],
		margin: 14,
		responsive: {
			0: {
				items: 2
			},
			480: {
				items: 4
			},
			740: {
				items: 4
			},
			940: {
				items: 7
			}
		},

	}

	constructor() {
		this.baseUrl = environment.baseUrl + '/assets';
		this.imagepath = environment.backendUrl + '/public/';
	}

}
